// ** React Import

// ** Custom Components
import Sidebar from '@components/sidebar';
import ToastError from '@components/toast/ToastError';

// ** Utils
// import { selectThemeColors } from '@utils';

import { achievementsOptions } from '../../utility/Options';

// ** Third Party Components
import * as yup from 'yup';
import { Formik } from 'formik';

// ** Reactstrap Imports
import { Button, Label, FormFeedback, Form, Input, Row, Col } from 'reactstrap';
import toast from 'react-hot-toast';
import FileUploaderSingle from '@components/input/FileUploaderSingle';
import api from '../../graphql/api';

// ** Graphql
import {
  CreateAccomplishment,
  UpdateAccomplishment
} from '../../graphql/Mutation/accomplishment';
import { useMutation } from '@apollo/client';
import { makeUniqueId } from '@apollo/client/utilities';
import { DownloadCloud } from 'react-feather';
import { useState } from 'react';

// ** Schema yup
const Schema = yup.object().shape({
  type: yup
    .string()
    .not(['EMPTY'], 'Tienes que seleccionar una opcion valida')
    .required(),
  cover: yup.string().required('Tienes que subir un archivo valido'),
  status: yup
    .string()
    .not(['initial'], 'Por favor seleccione otro estado')
    .required('Este campos es requerido'),
  quantity: yup.number().required('Tienes que colocar un monto')
});

const CoverUploadComponent = ({ handleChange, values }) => {
  const [avatar, setAvatar] = useState(values.cover ? values.cover : '');
  const [prev] = useState(values.cover ? values.cover : '');
  const [progress, setProgress] = useState({
    per: 0,
    text: '0%',
    started: false
  });
  const handleUpdateState = (value) => {
    const e = {
      target: {
        name: 'cover',
        value
      }
    };
    handleChange(e);
  };

  const handleFileUpload = async (files) => {
    try {
      const data = new FormData();
      data.append('file', files[0]);
      const config = {
        onUploadProgress(progressEvent) {
          const percentCompleted = Math.round(
            (progressEvent.loaded / progressEvent.total) * 100
          );
          const text = `${percentCompleted}%`;
          setProgress({
            per: percentCompleted,
            text,
            started: true
          });
        }
      };
      const res = (await api.post('/accomplishment/file-upload', data, config))
        .data;
      setAvatar(res.uri);
      handleUpdateState(res.uri);
    } catch (e) {}
  };

  const handleImgChange = () => {
    setAvatar('');
    handleUpdateState('');
  };

  const handleImgReset = () => {
    setAvatar(prev);
    handleUpdateState(prev);
  };

  return (
    <Row>
      {!avatar && (
        <Col>
          <FileUploaderSingle
            handleSubmit={handleFileUpload}
            accept=".jpg,.png,.jpeg"
            show={!values.cover}
          >
            <>
              <Label className="form-label fs-6 mb-1" for="cover">
                Imagen
              </Label>
              <div
                className="px-5 py-2 d-flex align-items-center justify-content-center flex-column"
                style={{
                  border: '1px dashed #7367F0',
                  borderRadius: '2.5px'
                }}
              >
                <DownloadCloud size={64} />
                <p className="text-secondary">
                  Suelta archivos aca o{' '}
                  <a href="/" onClick={(e) => e.preventDefault()}>
                    navega
                  </a>
                </p>
                {progress.started && (
                  <div
                    className="progress"
                    style={{ width: '100%', height: 15, bottom: 0 }}
                  >
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{
                        background: '#4DFF84',
                        width: `${progress.text}`
                      }}
                      aria-valuenow={progress.per}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >
                      {progress.text}
                    </div>
                  </div>
                )}
              </div>
            </>
          </FileUploaderSingle>
          {values.cover && (
            <div className="d-flex align-items-center justify-content-center mt-75 ms-1">
              <Button color="danger" size="sm" outline onClick={handleImgReset}>
                Reiniciar
              </Button>
            </div>
          )}
        </Col>
      )}
      {avatar && (
        <Col md={4}>
          <div className="d-flex">
            <div className="me-25">
              <img
                className="rounded me-50"
                src={avatar}
                alt="Generic placeholder image"
                height="250"
                width="250"
              />
              <div className="d-flex align-items-center justify-content-center mt-75 ms-1">
                <Button
                  color="danger"
                  size="sm"
                  outline
                  onClick={handleImgChange}
                >
                  Cambiar
                </Button>
              </div>
            </div>
          </div>
        </Col>
      )}{' '}
    </Row>
  );
};

const FormSidebar = ({ open, toggleSidebar, defaultValues }) => {
  // ** mutations **
  const [handle] = useMutation(
    defaultValues?._id ? UpdateAccomplishment : CreateAccomplishment
  );
  // ** States
  const handleSidebarClosed = () => {};

  const onSubmit = async (values) => {
    const data = {
      ...values,
      quantity: parseInt(values.quantity),
      status: String(values.status) === 'true',
      disable: false,
      __typename: undefined,
      reached: undefined,
      _id: undefined
    };
    let variables = { input: data };
    if (defaultValues?._id) {
      variables = {
        input: {
          _id: defaultValues._id,
          data
        }
      };
    }
    try {
      await handle({
        variables
      });
      toggleSidebar();
    } catch (e) {
      const errors = e.graphQLErrors;
      errors?.forEach((error) => {
        const message =
          error?.extensions?.exception?.response?.es ||
          error?.extensions?.response?.message[0];
        toast((t) => <ToastError t={t} message={message} />);
      });
    }
  };

  const handleValidateForm = async ({ validateForm, setErrors, values }) => {
    const errors = await validateForm();
    if (Object.keys(errors).length) {
      setErrors(errors);
      return;
    }
    await onSubmit(values);
  };

  const lisTitles = [
    { type: 'road', title: 'Caminos finalizados' },
    { type: 'episode', title: 'Episodios completados' },
    { type: 'streak', title: 'Días en la app de Subliful' },
    { type: 'premium', title: 'Meses con plan Premium' },
    { type: 'tags', title: 'Puntos en cualquier emoción' }
  ];

  const handleChangeActivity = (e, setFieldValue) => {
    const title = lisTitles.find((item) => item.type === e.target.value);
    setFieldValue('type', e.target.value);
    setFieldValue('title', title.title);
  };

  return (
    <Sidebar
      size="lg"
      open={open}
      title={defaultValues?._id ? 'Editar Logro' : 'Crear Logro'}
      headerClassName="mb-1"
      contentClassName="pt-0"
      toggleSidebar={toggleSidebar}
      onClosed={handleSidebarClosed}
    >
      <Formik
        initialValues={defaultValues}
        validateOnChange
        validateOnBlur
        validationSchema={Schema}
      >
        {({
          values,
          handleChange,
          handleBlur,
          errors,
          touched,
          setErrors,
          validateForm,
          setFieldValue
        }) => (
          <Form>
            <div className="mb-1">
              <Label className="form-label" for="type">
                Tipo de actividad <span className="text-danger">*</span>
              </Label>
              <Input
                type="select"
                name="type"
                id="type"
                onChange={(e) => handleChangeActivity(e, setFieldValue)}
                onBlur={(e) => handleChangeActivity(e, setFieldValue)}
                invalid={errors.type && true}
                value={values.type}
              >
                <option value="EMPTY" disabled>
                  Caminos | Episodios | Racha | Meses Premium | Emociones
                </option>
                {achievementsOptions.map((item) => (
                  <option key={makeUniqueId(item.value)} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </Input>
              {errors.type && touched.type && (
                <FormFeedback>Requerido</FormFeedback>
              )}
            </div>

            <div className="mb-1">
              <Label className="form-label" for="title">
                Titulo
              </Label>
              <Input
                type="text"
                name="title"
                id="title"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.title}
                placeholder="Titulo del logro"
                invalid={errors.title && true}
                disabled
              />
              {errors.title && touched.title && (
                <FormFeedback>{errors.title}</FormFeedback>
              )}
            </div>

            <div className="mb-1">
              <Label className="form-label" for="quantity">
                Cantidad de veces <span className="text-danger">*</span>
              </Label>
              <Input
                type="select"
                name="quantity"
                id="quantity"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.quantity}
                invalid={errors.quantity && true}
                required
              >
                {Array(100)
                  .fill()
                  .map((_, idx) => (
                    <option key={makeUniqueId(idx)} value={idx + 1}>
                      {idx + 1}
                    </option>
                  ))}
              </Input>
            </div>

            <div className="mb-1">
              <CoverUploadComponent
                handleChange={handleChange}
                values={values}
              />
              {errors.cover && <div className="text-danger">Requerido</div>}
            </div>

            <div className="mb-1">
              <Label className="form-label" for="status">
                Estado
              </Label>
              <Input
                type="select"
                name="status"
                id="status"
                placeholder="Seleccionar Estado"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.status}
                invalid={errors.status && true}
                required
              >
                <option disabled value="initial">
                  Seleccionar Estado
                </option>
                <option value={true}>Activo</option>
                <option value={false}>Inactivo</option>
              </Input>
              {errors.status && touched.status && (
                <FormFeedback>Requerido</FormFeedback>
              )}
            </div>
            <div style={{ height: '100px' }} />
            <Button
              className="me-1 mt-1"
              color="primary"
              onClick={() =>
                handleValidateForm({ validateForm, setErrors, values })
              }
            >
              {defaultValues?._id ? `Actualizar` : `Crear`}
            </Button>
          </Form>
        )}
      </Formik>
    </Sidebar>
  );
};

export default FormSidebar;
